/**
 * Date-extensions locale Armenian [hy-am]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('hy-am', {
    monthNames: ['հունվար','փետրվար','մարտ','ապրիլ','մայիս','հունիս','հուլիս','օգոստոս','սեպտեմբեր','հոկտեմբեր','նոյեմբեր','դեկտեմբեր'],
    monthShortNames: ['հնվ','փտր','մրտ','ապր','մյս','հնս','հլս','օգս','սպտ','հկտ','նմբ','դկտ'],
    dayNames: ['կիրակի','երկուշաբթի','երեքշաբթի','չորեքշաբթի','հինգշաբթի','ուրբաթ','շաբաթ'],
    dayShortNames: ['կրկ','երկ','երք','չրք','հնգ','ուրբ','շբթ']
});
